// Personal preferences — today only the landing-page Focus.
// Server: apps/api/src/routes/me.ts (GET /v1/me/preferences,
// PUT /v1/me/preferences/focus).
import type { FocusAreaId } from '@cyber-aware/shared-types';
import { jsonOrThrow } from './apiError';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';

export interface FocusPreference {
  areas: FocusAreaId[];
  updatedAt: number | null;
}

/** `null` focus = the person has never chosen one. */
export async function fetchPreferences(idToken: string): Promise<{ focus: FocusPreference | null }> {
  const res = await fetch(`${API_URL}/v1/me/preferences`, {
    headers: { authorization: `Bearer ${idToken}` },
  });
  return jsonOrThrow<{ focus: FocusPreference | null }>(res);
}

export async function saveFocusPreference(idToken: string, areas: FocusAreaId[]): Promise<{ focus: FocusPreference }> {
  const res = await fetch(`${API_URL}/v1/me/preferences/focus`, {
    method: 'PUT',
    headers: { authorization: `Bearer ${idToken}`, 'content-type': 'application/json' },
    body: JSON.stringify({ areas }),
  });
  return jsonOrThrow<{ focus: FocusPreference }>(res);
}
